import { useHistory } from 'react-router-dom';
import qs from 'querystring';

const useHistorySearchQuery = () => {
  const history = useHistory();

  const query = qs.decode(history.location.search.slice(1));

  return query;
};

export default useHistorySearchQuery;
